import level3ComunicazioniBoxLaterali 
    from './level3-04-comunicazioni-01-box-laterali.js';
import level3ComunicazioniCTA 
    from './level3-04-comunicazioni-02-cta.js';
    
const data = {
  "box-laterali": {
    label: "Box laterali",
    img: "./images/04-comunicazioni-01-boxlaterali.jpg",
    imgDescription: "Immagine che mette in evidenza i box laterali presenti sul primo, secondo e terzo foglio della bolletta.",
    description: "Nella parte destra delle pagine della bolletta abbiamo raccolto tante informazioni utili per te!",
    labelKeywords: ["box", "riquadri", "riquadro", "laterali", "laterale"],
    contentKeywords: ["box", "riquadri", "riquadro", "laterali", "laterale"],
    level3: level3ComunicazioniBoxLaterali
  },
  "comunicazioni-in-primo-piano": {
    label: "Comunicazioni in primo piano",
    img: "./images/04-comunicazioni-02-cta.jpg",
    imgDescription: "Immagine del primo e secondo foglio della bolletta di cui vengono messi in risalto dei box con alcuni messaggi utili per il cliente.",
    description: "Uno spazio dedicato a comunicazioni specifiche con consigli o informazioni che potrebbero esserti utili.",
    labelKeywords: ["cta"],
    contentKeywords: ["cta"],
    level3: level3ComunicazioniCTA
  },
  
  "informazioni-clienti": {
    label: "Informazioni utili per i clienti",
    img: "./images/04-comunicazioni-03-informazioniclienti.jpg",
    imgDescription: "Immagine che raffigura il secondo e terzo foglio della bolletta con evidenziate le informazioni per il cliente.",
    description: "In fondo alla bolletta abbiamo raccolto informazioni che possono esserti utili come il costo medio dell'energia che hai pagato e la lista dei metodi di pagamento che puoi consultare anche <a href='/guida_bolletta?level1=metodologie-pagamento'>qui</a>.",
    labelKeywords: ["informazioni", "clienti"],
    contentKeywords: ["informazioni", "clienti"]
  },

  "comunicazione-arera": {
    label: "Comunicazione dell'Autorità di Regolazione per l'Energia Rete ed Ambiente",
    img: "./images/04-comunicazioni-04-comunicazioniARERA.jpg",
    imgDescription: "Immagine che raffigura la sezione della bolletta contenente le comunicazioni ai clienti da parte dell'Autorità di Regolazione per l'Energia Rete ed Ambiente",
    description: "In questa sezione, prevista da ARERA in base all’art. 10 della Bolletta 2.0, si trovano le comunicazioni ai clienti da parte dell'autorità di regolazione per energia reti e ambiente.",
    labelKeywords: ["comunicazione", "autorità", "regolazione", "energia", "rete", "ambiente", "arera"],
    contentKeywords: ["comunicazione", "autorità", "regolazione", "energia", "rete", "ambiente", "arera"]
  }
}

export default data;